import { NavLink } from 'react-router-dom';
import logo from 'assets/images/ecoservice-logo.png';

import s from './Logo.module.css';

const Logo = () => {
  return (
    <NavLink to="/" className={s.logoWrapper}>
      <img src={logo} alt="ecoservice-logo" width="100%" />
    </NavLink>
  );
};

export default Logo;
